import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-bottom",
  "use": "icon-chevron-bottom-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-chevron-bottom\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.70711 11.6066L13.6568 6.65684L12.9497 5.94973L8 10.8995L3.05027 5.94973L2.34316 6.65684L7.29289 11.6066L7.29288 11.6066L7.99998 12.3137L8 12.3137L8.00002 12.3137L8.70712 11.6066L8.70711 11.6066Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol